import { requestCarrierAPI } from 'shared/api/CarrierAPIClient';

export function useDriverFeedbackAPI() {
  return {
    saveDriverFeedback: (text: string) => {
      return requestCarrierAPI('POST /internal/mobile/v1/feedback/', {
        json: { text },
      });
    },
  };
}
